import { graphqlApolloClient as client } from "../graphql-apollo-client"
import { GET_REQUEST_F21 } from "./graphql/queries/get-request-f21"

export const getRequestF21 = async ({projectId}) => {
  const { data } = await client.query({
    query: GET_REQUEST_F21,
    fetchPolicy: "network-only",
    variables: {
      projectId
    }
  })
  return data?.ProjectBeneficiariesByProjectWithF21Data || []
}
